import { ValueFormHealth } from "../../../../../../constants/health";

export const DefaultValueFormHealth = (isDisabled: boolean = false): ValueFormHealth => {
  return {
    value: "",
    errorCode: "",
    disabled: isDisabled,
    code: "",
  };
};

export interface PersonalDataDto {
  name: ValueFormHealth;
  lastName1: ValueFormHealth;
  lastName2: ValueFormHealth;
  birthDate: ValueFormHealth;
  docType: ValueFormHealth;
  docNumber: ValueFormHealth;
  sex: ValueFormHealth;
  nationality: ValueFormHealth;
  nationalityLabel: string;
  passportDate: ValueFormHealth;
  physicalPerson: boolean;
  tc2: ValueFormHealth;
  reta: ValueFormHealth;
  responsable: ValueFormHealth;
}

export const DefaultPersonalData = (): PersonalDataDto => {
  return {
    name: DefaultValueFormHealth(),
    lastName1: DefaultValueFormHealth(),
    lastName2: DefaultValueFormHealth(),
    birthDate: DefaultValueFormHealth(),
    docType: DefaultValueFormHealth(),
    docNumber: DefaultValueFormHealth(),
    sex: DefaultValueFormHealth(),
    nationality: DefaultValueFormHealth(),
    nationalityLabel: "",
    passportDate: DefaultValueFormHealth(),
    physicalPerson: true,
    tc2: DefaultValueFormHealth(),
    reta: DefaultValueFormHealth(),
    responsable: DefaultValueFormHealth(),
  };
};
